<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1" style="margin: 0px">{{ tajukKad }}</p>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <el-table
            :default-sort="{ prop: 'name', order: 'descending' }"
            :data="quotaAdditionArray"
            v-loading.body="loading"
            element-loading-text="Loading"
            @sort-change="sortChange"
            fit
            highlight-current-row
          >
            <el-table-column
              label="No."
              width="50" type="index" :index="indexMethod">
            </el-table-column>
            <el-table-column
              prop="userGeneralName"
              label="Tarikh Permohonan"
              min-width="200"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word; color: var(--darker-border-color);">{{ scope.row.quotaAdditionRequestDate | formatDate }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="Status"
              width="120"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row.quotaAdditionResponseDecision === 'approved' ? 'Lulus' : scope.row.quotaAdditionResponseDecision === 'rejected' ? 'Gagal' : 'Menunggu Keputusan' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="quotaAdditionResponseRemarks"
              label="Butiran"
              width="150"
              :sortable="false">
              <template slot-scope="scope">
                <div v-if="scope.row.quotaAdditionResponseDecision !== ''" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <!-- <span style="word-break: break-word;">{{ scope.row.quotaAdditionResponseRemarksShort ? scope.row.quotaAdditionResponseRemarksShort : '-' }}</span>
                  <a v-if="scope.row.remarks2ShortFlag === true" class="fileLink" style="font-size: 14px; margin: 0px;" @click="readMoreRestrictionReleasedRemarksDialog(scope.row)">Lihat lagi</a> -->
                  <span style="word-break: break-word;">{{ scope.row.quotaAdditionResponseAmount | formatNumber }}</span>
                  <span class="tablesubheading">{{ scope.row.quotaAdditionResponseDate | formatDate }}</span>
                  <!-- <span class="tablesubheading">
                    {{ scope.row.kpdnResponsePICName ? scope.row.kpdnResponsePICName : '-' }}
                  </span> -->
                </div>
                <div v-else style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">Menunggu Keputusan</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="quotaAdditionRequestRemarks"
              label="Tempoh"
              width="240"
              :sortable="false">
              <template slot-scope="scope">
                <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                  <span style="word-break: break-word;">{{ scope.row | formatTempoh }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="Ulasan"
      :visible.sync="userReadMore"
      :before-close="resetForm">
      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center;">
        <span class="readMoreRemarks">{{ currentRemarks }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="secondary" @click="resetForm">Tutup</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  activeTickFleetCardVehicles,
  personalExcelFleetCardVehicles
} from "@/api/mydiesel/mydieselFleetCardVehicles";
import moment from 'moment'
export default {
  name: 'vehicle-new-diesel',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      currentMonth: null,
      userReadMore: false,
      currentCompanyName: '',
      currentVehicleNumber: '',
      currentRemarks: '',
      currentRestrictionImposedRemarks: '',
      currentRestrictionReleasedRemarks: '',
      loading: false,
      btnloading: false,
      filteredUsers: [],
      search: "",
      itemLoading7: false,
      options7: [],
      itemLoading8: false,
      options8: [],
      incomingFiles: [],
      dateType: 'year',
      dates: '',
      currId: "",
      currId2: "",
      currRow: null,
      fleetcardrestrictionfileSekatan: [],
      fleetcardrestrictionfileLepasan: [],
      userReleaseRestriction: false,
      userViewReleasedRestrictionDocuments: false,
      userReleaseRestrictionDialog: false,
      userDeleteFile: false,
      fleetcardrestrictionfile: null,
      total: 0,
      page: 1,
      limit: 100,
      serviceName: process.env.SERVICE_NAME,
      locked: false
    }
  },
  methods: {
    resetForm() {
      this.userReadMore = false
      this.currentCompanyName = ''
      this.currentVehicleNumber = ''
      this.currentRemarks = ''
    },
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    },
    rowClick(row, column) {
      // if (column.label !== '#' && column.label !== 'Tindakan') {
      //   row.vehicleActiveTickedFlag = row.vehicleActiveTickedFlag === true ? false : true
      // }
    },
    async personalExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let resp = await personalExcelFleetCardVehicles(this.$store.state.app.branchSelected, this.registerForm.branchId)
        var link = document.createElement('a')
        link.href = URL.createObjectURL(new Blob([resp]))
        var fileName = `Senarai Kenderaan-${moment().unix()}.xlsx`
        link.download = fileName
        link.click()
      } catch (err) {
        console.log("download excel", err)
      }
      loading.close()
    },
    async selectAll() {
      const allChecked = this.quotaAdditionArray.every((item) => {
        const firstFlag = this.getVehicleStatusValue(item) === false ? true : false
        const secondFlag = !firstFlag ? item.vehicleActiveTickedFlag === true ? true : false : true
        return secondFlag
      })
      await this.quotaAdditionArray.forEach(async (item) => {
        if (this.getVehicleStatusValue(item) === true) {
          item.vehicleActiveTickedFlag = !allChecked;
          try {
            await this.toggleVehicleTicked(item, false);
          } catch (err) {
            console.log("err", err)
          }
        }
      })
      if (!allChecked) {
        this.$message({
          message: 'Kenderaan telah diaktifkan',
          type: 'success'
        })
      } else {
        this.$message({
          message: 'Kenderaan telah dinyahaktifkan',
          type: 'success'
        })
      }
    },
    async toggleVehicleTicked(row, promptMessage) {
      try {
        const payload = {
          vehicleActiveTickedFlag: row.vehicleActiveTickedFlag
        }
        await activeTickFleetCardVehicles(this.$store.state.app.branchSelected, row._id, payload)
        if (row.vehicleActiveTickedFlag) {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah diaktifkan',
              type: 'success'
            })
          }
        } else {
          if (promptMessage) {
            this.$message({
              message: 'Kenderaan telah dinyahaktifkan',
              type: 'success'
            })
          }
        }
      } catch (err) {
        console.log("err", err)
      }
    },
    getVehicleStatusLabel(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return "RAYUAN LULUS"
      }
      if (!vehicleValidBodyFlag) {
        return "JENIS BADAN TIDAK LAYAK"
      }
      if (!vehicleValidModelFlag) {
        return "KELAS KEGUNAAN TIDAK LAYAK"
      }
      if (vehicleRoadTaxPassedFlag) {
        return "TAMAT CUKAI JALAN"
      }
      return "KENDERAAN LAYAK"
    },
    getVehicleStatusValue(row) {
      const vehicleValidBodyFlag = row.vehicleValidBodyFlag ? true : false
      const vehicleValidModelFlag = row.vehicleValidModelFlag ? true : false
      const vehicleRoadTaxPassedFlag = row.vehicleRoadTaxPassedFlag ? true : false
      const vehicleActiveTickedFlag = row.vehicleActiveTickedFlag ? true : false
      const vehicleFinalQuotaValidFlag = row.vehicleFinalQuotaValidFlag ? true : false
      const vehicleAppealQuotaValidFlag = row.vehicleAppealQuotaValidFlag ? true : false

      if (vehicleAppealQuotaValidFlag) {
        return true
      }
      if (!vehicleValidBodyFlag || !vehicleValidModelFlag || vehicleRoadTaxPassedFlag) {
        return false
      }
      return true
    },
    async navigateToWebPage(webpage) {
      this.$router.push(`/z/${this.$store.state.app.branchSelected}/mydiesel/${webpage}`)
    },
    readMoreRestrictionReleasedRemarksDialog(row) {
      this.userReadMore = true
      this.currentRemarks = row.quotaAdditionResponseRemarks
    },
    releaseViewFleetCardQuotaAddition(index, row) {
      this.currId = row._id;
      this.currentCompanyName = row.userGeneralName ? row.userGeneralName : row.mydieseluserprofileId.userGeneralName
      this.currentVehicleNumber = row.restrictionType === 'account' ? 'Semua' : row.restrictionVehicleNumber
      this.currUser = {
        ...row
      }
      this.locked = row.restrictionReleasedFlag
      this.fleetcardrestrictionfileSekatan = row.fleetcardrestrictionfileSekatan
      this.fleetcardrestrictionfileLepasan = row.fleetcardrestrictionfileLepasan
      this.userReleaseRestriction = true;
    },
    indexMethod(index) {
      return index + 1 + (this.page - 1) * this.limit;
    },
    sortChange({ prop, order }) {
      this.currentSortProp = prop
      this.currentSortOrder = order
      this.fetchData()
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    quotaAdditionArray: {
      type: Array
    },
    searchKenderaan: {
      type: String
    },
    handleVehicleDelete: {
      type: Function
    },
    saveAndNavigate: {
      type: Function
    },
    viewRayuan: {
      type: Function
    },
    profileVehicleType: {
      type: String
    },
    locked: {
      type: Boolean
    },
    tickedless: {
      type: Boolean
    },
    rayuanless: {
      type: Boolean
    },
    registerForm: {
      type: Object
    }
  },
  filters: {
    formatProfileVehicleType(val) {
      switch (val) {
        case 'awambarangan': return 'AWAM & BARANGAN'
        case 'awam': return 'AWAM'
        case 'barangan': return 'BARANGAN'
        default: return '-'
      }
    },
    formatDateTime(val) {
      if (val !== undefined) {
        return moment.unix(Number(val)).format('DD/MM/YYYY HH:mm')
      }
      return ''
    },
    formatDate(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
    formatTempoh(val) {
      const startDate = val.quotaAdditionStartDate
      const endDate = val.quotaAdditionEndDate
      if (!startDate || !endDate) {
        return '-'
      }
      const startDateMoment = moment(startDate).format('DD/MM/YYYY')
      const endDateMoment = moment(endDate).subtract(1, 'day').format('DD/MM/YYYY')
      return startDateMoment + ' - ' + endDateMoment
    }
  },
  computed: {
    kenderaanKuotaAsa() {
      return Number(this.quotaAdditionArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaBase) ? Number(item.vehicleQuotaBase) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.quotaAdditionArray.reduce((acc, item) => {
        const value = Number(item.vehicleQuotaCurrent) ? Number(item.vehicleQuotaCurrent) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    },
    currentMonthLabel() {
      switch (this.currentMonth) {
        case '01': return 'JANUARI'
        case '02': return 'FEBRUARI'
        case '03': return 'MAC'
        case '04': return 'APRIL'
        case '05': return 'MEI'
        case '06': return 'JUN'
        case '07': return 'JULAI'
        case '08': return 'OGOS'
        case '09': return 'SEPTEMBER'
        case '10': return 'OKTOBER'
        case '11': return 'NOVEMBER'
        case '12': return 'DISEMBER'
      }
    }
  },
  mounted() {
    this.currentMonth = moment().format('MM')
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mydiesel/components/QuotaAdditionalNewDiesel.vue